export const nameExp = "^[a-zA-Z ]*[a-zA-Z]$";
export const numberExp = "^[0-9]+$";
export const alphabetExp = "^[a-zA-Z ]+$";
export const emailExp =
  "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$";
export const numberDoubleExp = "^[0-9]*(.)?([0-9]*)?[0-9.]$";
export const numberDouble4DecimalExp = "^[0-9]+(.)?([0-9]{1,4})?$";
export const numberTelephone =
  "/^[+]?(1-|1s|1|d{3}-|d{3}s|)?(((d{3}))|d{3})(-|s)?(d{3})(-|s)?(d{4})$/g";
export const phoneNo = "^[+0-9]+$";
